import React from 'react';

import BonusStep from '../../../../assets/icons/bonus.svg';
import CompletedStep from '../../../../assets/icons/greencheck.svg';
import Vector from '../../../../assets/icons/vector.svg';
import ProgressBarsContent from '../ProgressBarsContent';

interface StepOneActiveProps {
  classname: string;
  vectorClassname: string;
  hideBonusIcon?: boolean;
}

const StepOneCompleted = ({ classname, vectorClassname, hideBonusIcon }: StepOneActiveProps) => (
  <div className={classname}>
    <div>
      <CompletedStep />
      <Vector className={vectorClassname} />
      <div>2</div>
      <Vector />
      <div>3</div>
      <Vector />
      {!hideBonusIcon && (
        <div>
          <BonusStep />
        </div>
      )}
    </div>
    <ProgressBarsContent />
  </div>
);

export default StepOneCompleted;
